import {BaseAnalyticsEvent} from "./base-analytics-event";

export class KeyEvent extends BaseAnalyticsEvent {

  constructor(value, label = 'key', action = '', category = 'web') {
    super(value, label, action, category);
  }
}
